import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import api from '../../services/api';
import Swal from 'sweetalert2';

const CPFAuthorizedList = () => {
    const [cpfs, setCpfs] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [searchText, setSearchText] = useState('');

    const loadCPFs = useCallback(async () => {
        setLoaded(false);
        const returnCPFs = await api.get("/cpf-authorized");
        setCpfs(returnCPFs.data);
        setLoaded(true);
    }, []);

    useEffect(() => {
        loadCPFs();
    }, [loadCPFs]);

    const normalizeCPF = (cpf) => String(cpf || '').replace(/\D/g, '');

    const handleSearchBar = () => {
        // chamado ao "confirmar" a busca (ex: Enter ou botão de lupa),
        // dependendo de como o Layout dispara esse callback
    };

    const filteredCPFs = searchText
        ? cpfs.filter(cpfAuthorized =>
            normalizeCPF(cpfAuthorized.cpf).includes(normalizeCPF(searchText))
        )
        : cpfs;

    const deleteCPF = async (cpf) => {
        setLoaded(false);

        await api.delete(`/cpf-authorized/${cpf._id}`);

        setCpfs(prevCpfs => prevCpfs.filter(c => c !== cpf));
        setLoaded(true);
    };

    return (
        <Layout
            menuActive="dashboard"
            pageTitle="CPFs Autorizados"
            enableSearchBar={true}
            searchTerm={searchText}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={handleSearchBar}
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                <small><Link className="label label-default" to="/dashboard">Dashboard</Link></small> <span className="label label-success">CPFs Autorizados</span>
                            </div>
                            <ul className="card-action">
                                <li>
                                    <Link to="/cpfs-autorizado/novo" className="btn btn-sm btn-success">
                                        Novo <i className="fa fa-plus"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className={`card-body table-responsive ${loaded ? "" : "__loading"}`}>
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <table className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th className="right">CPF</th>
                                                <th>Opções</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredCPFs.length > 0 ? (
                                                    filteredCPFs.map((cpfAuthorized, index) => (
                                                        <tr key={index}>
                                                            <td style={{ width: '90%' }}>{cpfAuthorized.cpf}</td>
                                                            <td style={{ width: '10%' }}>
                                                                <div className="col-xs-12">
                                                                    <button
                                                                        className="btn btn-xs btn-danger"
                                                                        onClick={() => deleteCPF(cpfAuthorized)}
                                                                        style={{ width: '100%' }}
                                                                    >
                                                                        Excluir <div className="icon fa fa-trash-o"></div>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="2" className="text-center">
                                                            Nenhum CPF encontrado.
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>

    );
};

export default CPFAuthorizedList;